import React from 'react';
import { useDispatch } from 'react-redux';
import { Step } from 'components/SteppedModal';
import SocialShareModalFooterAuthButton from 'containers/SocialShareModal/SocialShareModalFooter/SocialShareModalFooterAuthButton';
import SocialShareModalFooterCancelButton from 'containers/SocialShareModal/SocialShareModalFooter/SocialShareModalFooterCancelButton';
import { hideModal } from 'redux/modules/modal';
import { Dispatch } from 'redux/types';
import { FacebookSocialShareStep } from '../../types';
import FacebookPermissionStep from './FacebookPermissionStep';

export default function useFacebookPermissionSte(): Step<
  FacebookSocialShareStep
> {
  const dispatch = useDispatch<Dispatch>();

  return {
    id: 'permission',
    component: <FacebookPermissionStep />,
    fluidFooterButtons: true,
    renderFooterButtons: () => [
      <SocialShareModalFooterCancelButton
        key="cancel"
        onCancel={() => dispatch(hideModal())}
      />,
      <SocialShareModalFooterAuthButton key="auth">
        revise options
      </SocialShareModalFooterAuthButton>,
    ],
  };
}
